
//import errorHandler from './errorHandler'
import api from '../../../api'
import axios from 'axios';
import _ from 'lodash'
import qs from 'query-string'

 export default {
    decode : (payload, next) => {
        axios.post('https://www.juphy.com/decodebase64', payload.body)
          .then(function (response) {
            next(null, response.data);
          })
          .catch(function (err) {
            if(err) return next(err, null);
          });
    }
} 
 


// WEBPACK FOOTER //
// ./src/libs/system/services/base64.js